import NxFilterCheckboxes from '../components/Checkboxes';
import NxFilterDate from '../components/Date';
import NxFilterDates from '../components/Dates';
import NxFilterParentTaxonomy from '../components/ParentTaxonomy';
import NxFilterRadios from '../components/Radios';
import NxFilterSelect from '../components/Select';
import NxFilterSite from '../components/Site';
import NxFilterTaxonomy from '../components/Taxonomy';
import NxFilterTextInput from '../components/TextInput';
import NxFilterUniqueCheckbox from '../components/UniqueCheckbox';
import NxFilterEntity from '../components/Entity';

export const filters = {
  NxFilterCheckboxes,

  NxFilterDate,
  NxFilterDates,
  NxFilterParentTaxonomy,
  NxFilterRadios,
  NxFilterSelect,
  NxFilterSite,
  NxFilterTaxonomy,
  NxFilterTextInput,
  NxFilterUniqueCheckbox,
  NxFilterEntity,
};

export const multiValueFilters = [
  'NxFilterCheckboxes',
  'NxFilterSelect',
  'NxFilterSite',
  'NxFilterTaxonomy',
  'NxFilterEntity',
];

export default {
  filters,
};
